import { Bell, ChatCircleText, Printer, FolderOpen, ClipboardText, PaperPlaneTilt, Plus, Archive, UsersThree, SignOut, UserCircle, ArrowLeft, CaretRight, MapTrifold, ListBullets, Camera, CalendarBlank, Clock, CheckCircle, Warning, HardHat, MagnifyingGlass, CloudCheck, CloudSlash, ChartBar, ImageSquare, Microphone, StopCircle } from '@phosphor-icons/react';
/** Flat, scalable interpretation of the supplied Site Method brand mark. */
export function SiteMark() {
  return <svg className="site-method-mark" viewBox="0 0 64 70" aria-hidden="true" focusable="false"><path className="mark-forest" d="M3 32 46 4v27L3 59Z" /><path className="mark-teal" d="m29 44 17-11v26L29 70Z" /><path className="mark-bronze" d="m48 42 16-11v28L48 70Z" /></svg>;
}

export function SiteWordmark({ tagline = false }: { tagline?: boolean }) {
  return <div className="site-wordmark"><span>Site<br />Method</span>{tagline && <small>Build a clearer way</small>}</div>;
}

const icons = {
  bell: Bell, comment: ChatCircleText, print: Printer, projects: FolderOpen, snags: ClipboardText, invite: PaperPlaneTilt, plus: Plus, archive: Archive, team: UsersThree, signout: SignOut,
  account: UserCircle, back: ArrowLeft, next: CaretRight, map: MapTrifold, list: ListBullets, camera: Camera, calendar: CalendarBlank,
  clock: Clock, check: CheckCircle, warning: Warning, inspect: HardHat, search: MagnifyingGlass, offline: CloudCheck, disconnected: CloudSlash, progress: ChartBar, photo: ImageSquare, mic: Microphone, stop: StopCircle,
};
export type SiteIconName = keyof typeof icons;
export function SiteIcon({ name }: { name: SiteIconName }) {
  const Icon = icons[name];
  return <Icon className="site-icon" weight="regular" aria-hidden="true" focusable="false" />;
}
